import { render, staticRenderFns } from "./SelectMultipleMkb.vue?vue&type=template&id=2ee2fe19"
import script from "./SelectMultipleMkb.vue?vue&type=script&lang=js"
export * from "./SelectMultipleMkb.vue?vue&type=script&lang=js"
import style0 from "./SelectMultipleMkb.vue?vue&type=style&index=0&id=2ee2fe19&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports